import { Link } from 'react-router-dom';
import { useOffers } from '../../context/OffersContext';
import { offerHowItWorks } from '../../utils/offerMatch';
const GiftIcon = ({ className }) => <span className={`${className} inline-flex items-center justify-center`} aria-hidden="true">🎁</span>;
const ArrowRight = ({ className }) => <span className={className} aria-hidden="true">→</span>;

/** Under the price on the product page: every offer this product is part of, how it works, and the other pieces. */
const ProductOfferStrip = ({ product }) => {
  const { offersFor, sym } = useOffers();
  const offers = offersFor(product);
  if (!offers.length) return null;
  return (
    <div className="mt-5 space-y-2.5" data-testid="product-offers">
      {offers.map((o) => (
        <div key={o.code} className="flex gap-3 rounded-xl bg-primary-50 border border-primary/20 px-4 py-3">
          <GiftIcon className="w-5 h-5 text-primary shrink-0 mt-0.5" />
          <div className="text-[13px] leading-snug text-ink">
            <p className="font-semibold">{o.title}</p>
            <p className="text-ink-soft mt-0.5">{offerHowItWorks(o, sym)}</p>
            <Link to={`/offers/${encodeURIComponent(o.code)}`}
              className="inline-flex items-center gap-1 mt-1.5 text-xs font-semibold text-primary hover:underline">
              See everything in this offer <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductOfferStrip;
